<template>
  <div>
    <template v-if="tpPublicacao < 2">
      <div class="titlePage">Filtro</div>
      <div class="row mt-3">
        <div class="col-sm-3">
          <fcc-select
            class="mb-4"
            placeholder="Fase"
            labelField="idfase"
            valueField="idfase"
            :clearable="false"
            v-model="filtro.fase"
            :options="lstFase"
          >
            Escolha a fase
          </fcc-select>
        </div>
        <div class="col-sm-3" v-if="filtro.fase">
          <fcc-select
            class="mb-4"
            placeholder="Aplicação"
            :clearable="false"
            v-model="filtro.aplicacao"
            @change="filtrarCorrecaoCadastralOpcaos"
            :options="lstAplic[filtro.fase]"
          >
            Escolha a aplicação
          </fcc-select>
        </div>
        <div class="col-sm-3" v-if="filtro.aplicacao">
          <fccDateInput
            id="filagehorainicio"
            type="datetime"
            class="form-control"
            v-model="filtro.datainicio"
            min-datetime="today"
            required
            >Data/Hora inicial</fccDateInput
          >
        </div>
        <div class="col-sm-3" v-if="filtro.datainicio">
          <fccDateInput
            id="filagehorainicio"
            type="datetime"
            class="form-control"
            v-model="filtro.datafinal"
            min-datetime="today"
            required
            >Data/Hora final</fccDateInput
          >
        </div>
      </div>
      <div class="row mt-3" v-if="mostraTabela && filtro.datafinal">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fieldsCargos"
            :items="lstCargos"
            responsive
            :porPage="itemPorPage"
            :optionsButton="optionsCargos"
            @row-selected="selecionaCorrecao"
          ></fccTable>
        </div>
      </div>
    </template>
    <div class="row mt-3" v-if="tpPublicacao >= 0">
      <div class="col-sm-12">
        <div class="titlePage mb-3">Fase, Aplicação e Cargos Cadastrados</div>
        <fccTable
          striped
          hover
          :fields="fieldsControleCargos"
          :actions="actionsControleCargos"
          :items="lstControleCargos"
          responsive
          :porPage="itemPorPage"
          :optionsButton="optionsFase"
        ></fccTable>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
export default {
  data() {
    return {
      lstFase: [],
      filtro: {},
      lstCargos: [],
      lstAplic: {},
      lstControleCargos: [],
      mostraTabela: false,
      montarCorrecao: [],
      optionsCargos: [],
      optionsFase: [],
      itemPorPage: '1000',
      actionsControleCargos: [
        {
          button: true,
          funcaoButton: 'deleteCargos',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: this.tpPublicacao > 1 ? '' : store.state.permissaoMenu.editar
        }
      ],
      fieldsCargos: [
        {
          key: 'rowSelect',
          type: 'rowSelect',
          value: 'codopcao'
        },
        { key: 'opcao', label: 'Tipo de Publicação	', sortable: true },
        { key: 'numero', label: 'Número', sortable: true }
      ],
      fieldsControleCargos: [
        { key: 'idfase', label: 'Fase' },
        { key: 'idaplic', label: 'Aplicação' },
        { key: 'datainicial', label: 'Data inicial' },
        { key: 'datafinal', label: 'Data fim' },
        { key: 'codcargo', label: 'Opção' },
        { key: 'nmfuncionario', label: 'Técnico', sortable: true },
        { key: 'dataconf', label: 'Data Configuração' },
        { key: 'actions', label: '' }
      ]
    }
  },
  methods: {
    exportarCargos() {
      this.callConfirm('Deseja realmente exportar', '').then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C01'))
          axios
            .post(
              this.baseUrlPublicacao + 'PublicacaoCorrecaoCadastral/Exportar',
              this.idNotificacao,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listaControleCargos()
              this.$emit('liberarStatus')
            })
            .finally(this.carregaTexto)
        }
      })
    },
    listaControleCargos() {
      this.carregaTexto(this.codeMensagem('C01'))
      this.optionsFase = []
      axios
        .get(
          this.baseUrlPublicacao +
            'PublicacaoCorrecaoCadastral/CorrecaoCadastralRetornos/' +
            this.idNotificacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstControleCargos = response.data
          if (this.lstControleCargos.length > 0 && this.tpPublicacao < 2) {
            this.optionsFase = [
              {
                funcaoButton: 'exportarCargos',
                tooltip: 'Exportar',
                icon: 'file-export',
                variant: 'primary',
                text: 'Exportar',
                objpermCodigo: store.state.permissaoMenu.adicionar
              }
            ]
          } else {
            this.optionsFase = []
          }
          this.actionsControleCargos = [
            {
              button: true,
              funcaoButton: 'deleteCargos',
              icon: 'trash',
              tooltip: 'Excluir',
              objpermCodigo: this.tpPublicacao > 1 ? '' : store.state.permissaoMenu.editar
            }
          ]
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    },
    deletandoCargo(correcaoCadastral) {
      this.carregaTexto(this.codeMensagem('C02'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoCorrecaoCadastral/Excluir',
          correcaoCadastral,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listaControleCargos()
        })
        .finally(this.carregaTexto)
    },
    adicionandoCargo(correcaoCadastral) {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoCorrecaoCadastral/Adicionar',
          correcaoCadastral,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listaControleCargos()
        })
        .finally(this.carregaTexto)
    },
    montaCampos(editar = false, campo = null) {
      const correcao = {
        idPublicacao: this.idNotificacao,
        spi: this.controlePage.spi,
        idFase: editar ? campo.idfase : this.filtro.fase,
        idAplic: editar ? campo.idaplic : this.filtro.aplicacao,
        dataInicial: editar ? campo.datainicial : this.filtro.datainicio,
        dataFinal: editar ? campo.datafinal : this.filtro.datafinal,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario,
        listaCodCargo: editar ? [campo.codcargo] : this.montarCorrecao
      }
      return new Promise((resolve) => {
        resolve(correcao)
      })
    },
    deleteCargos(_, item) {
      this.callConfirm('Deletar cargo', item.codcargo).then((result) => {
        if (result.value) {
          this.montaCampos(true, item).then((response) => {
            this.deletandoCargo(response)
          })
        }
      })
    },
    adicionarCargos() {
      this.callConfirm('Adicionar cargos', '').then((result) => {
        if (result.value) {
          this.montaCampos().then((response) => {
            this.adicionandoCargo(response)
          })
        }
      })
    },
    selecionaCorrecao(itens) {
      this.montarCorrecao = []
      if (itens.length > 0) {
        itens.forEach((element) => {
          this.montarCorrecao.push(element.codopcao)
        })
        this.optionsCargos = [
          {
            funcaoButton: 'adicionarCargos',
            tooltip: 'Adicionar',
            icon: 'plus',
            variant: 'primary',
            text: 'Adicionar',
            objpermCodigo: store.state.permissaoMenu.adicionar
          }
        ]
      } else {
        this.optionsCargos = []
      }
    },
    filtrarCorrecaoCadastralOpcaos() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao +
            'PublicacaoCorrecaoCadastral/CorrecaoCadastralOpcaos/' +
            this.controlePage.spi +
            '/' +
            this.filtro.fase +
            '/' +
            this.filtro.aplicacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstCargos = response.data
          this.mostraTabela = true
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    },
    listarFaseSpi() {
      axios
        .get(
          this.baseUrlPublicacao +
            'PublicacaoCorrecaoCadastral/FiltroCorrecaoCadastral/' +
            this.controlePage.spi,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstFase = response.data
          if (this.lstFase.length) {
            this.lstFase.forEach((e) => {
              this.lstAplic[e.idfase] =
                this.lstAplic[e.idfase] != null ? this.lstAplic[e.idfase] : []
              this.lstAplic[e.idfase].push(e.idaplic)
            })
          }
        })
        .catch(this.setErrorSystem)
    }
  },
  props: {
    controlePage: Object,
    idNotificacao: Number,
    baseUrlPublicacao: String,
    tpPublicacao: Number
  },
  mounted() {
    this.permissao = this.permissaoPage.find((lista) => lista.objpermcodigo === 'X')
    this.listarFaseSpi()
    this.listaControleCargos()
  }
}
</script>
